import { call, put, takeEvery } from 'redux-saga/effects';
import { assignLead } from '../../requests/assign_lead_request';
import { assignLeadSuccess, assignLeadFailure } from '../actions/assign_lead.actions';
import { ASSIGN_LEAD } from '../constants/assign_lead.constants';
import { message_error, message_success } from '../../../../../components/Message';
import { getLeadAgent } from '../../../Lead_profile/requests/get_lead_profile_request';

function* assignLeadRequest({ userId, leadId }) {
    const { result, msg, error } = yield call(assignLead, userId, leadId);
    if (result) {
        yield put({ type: 'GET_LEAD_HISTORY_REQ', leadId });
        const lead = yield call(getLeadAgent, leadId);
        yield put(assignLeadSuccess(lead.options.ref_assigned_to));
        message_success('Assigned successfully!');
    } else {
        yield put(assignLeadFailure(error));
        message_error(msg);
    }
}

export default function* assignLeadSaga() {
    yield takeEvery(ASSIGN_LEAD, assignLeadRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/redux/sagas/assign_lead.saga.js